import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { DialogNewMemberComponent } from './dialog-new-member/dialog-new-member.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'settings-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class SettingsTeamComponent implements OnInit, OnChanges {
  @Input() idEmpresa: any[] = [];

  objetoGridConfiguration: any;
  nombreReporte: string;
  objetosSelected: any;
  datosevent: any;
  verGrid: boolean = false;

  constructor(
    private coalService: CoalService,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {
    this.ObjectGrid();
  }

  ngOnInit(): void {
    this.getTeam();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.idEmpresa?.currentValue) {
      this.getTeam();
    }
  }

  getTeam () {
    let filters = '';
    filters += `filters[id]=${this.idEmpresa}`
    
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?${filters}&populate=users_permissions_users.role`)
    .subscribe((res: any) => {
      this.verGrid = true;
      let users: any[] = [];
      res.data.forEach((empresa) => {
        empresa.attributes?.users_permissions_users?.data?.forEach((usuario) => {
          if(users.indexOf( users.indexOf(usuario) ) == -1 ) {
            users = users.concat(usuario);
          }
        });
      });
      this.objetoGridConfiguration.Data = users;
      this.store.dispatch(OcultarSpinner());
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    })
  }

  newMember (data) {
    const dialogRef = this.dialog.open(DialogNewMemberComponent, {
      width: '700px',
      data: {...data},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result.success) {
        this.getTeam();
      }
    });
  }

  modify () {
    const dialogRef = this.dialog.open(DialogNewMemberComponent, {
      width: '700px',
      data: this.datosevent[0],
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.success == 1) {
        this.getTeam();
      }
    })
  }

  delete () {
    if ( this.datosevent[0]?.id ) {
      this.store.dispatch(MostrarSpinner());
      this.coalService.deleteService(`ope-empresas/member`, this.datosevent[0].id)
      .subscribe((res: any) => {
        this.store.dispatch(OcultarSpinner());
        this.getTeam()
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
        this._snackBar.open(
          'Ocurrió un error al eliminar el usuario',
          'OK',
          { duration: 5000 }
        )
      })
    }
  }

  datosMessage ($event) {
    this.datosevent = $event.data;
  }

  ObjectGrid() {
    let that = this;
    this.nombreReporte = 'Observaciones';
    this.objetoGridConfiguration = {
        GridOptions: {
            paginacion: 20,
            pageSize: ['40', '60', '80', '100'],
        },
        ExportExcel: { enabled: false, fileName: 'Historico' },
        ColumnHiding: { hide: true },
        Checkbox: { checkboxmode: 'single' },
        Editing: { allowupdate: true, mode: 'cell' },
        Columnchooser: { columnchooser: true },
        SearchPanel: {
            visible: true,
            width: 200,
            placeholder: 'Buscar...',
            filterRow: true,
        },
        Scroll: { mode: 'infinite' },
        Color: null,
        Detail: { detail: true },
        ToolbarDetail: null,
        ToolBox: [
          {
              location: 'after',
              widget: 'dxButton',
              locateInMenu: 'auto',
              options: {
                  width: 60,
                  onClick: this.modify.bind(this),
                  icon: '../../../assets/icons/ver.png',
              },
              visible: true,
              name: 'simple',
          },
          {
              location: 'after',
              widget: 'dxButton',
              locateInMenu: 'auto',
              options: {
                  width: 60,
                  icon: '../../../assets/icons/borrar.png',
                  onClick: this.delete.bind(this),
              },
              visible: true,
              name: 'simple',
          },
        ],
        Columns: [],
        Data: [],
        Columns1: [1],
        Data1: [],
        datosMessage(evento) {
            that.objetosSelected = evento.data;
        },
    };
    this.DataColumnsGrid();
  }

  DataColumnsGrid() {
    let columnsMulti = [];
      columnsMulti.push({
        caption: 'Nombre',
        dataField: 'attributes.name',
        allowEditing: false,
        fixed: true,
      });
      columnsMulti.push({
        caption: 'Email',
        dataField: 'attributes.email',
        allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Rol',
        dataField: 'attributes.role.data.attributes.name',
        allowEditing: false,
    });
    this.objetoGridConfiguration.Columns = columnsMulti;
  }
}
